import { useState } from "react";

export function useAuth() {
  const [token, setToken] = useState(() => localStorage.getItem("token") || "");
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem("user") || "null"));
  const [requiresPasswordChange, setRequiresPasswordChange] = useState(false);

  const login = (t, u, rpc = false) => {
    setToken(t);
    setUser(u);
    setRequiresPasswordChange(rpc);
    localStorage.setItem("token", t);
    localStorage.setItem("user", JSON.stringify(u));
  };

  const logout = () => {
    setToken("");
    setUser(null);
    setRequiresPasswordChange(false);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  const clearPasswordChangeRequirement = () => {
    setRequiresPasswordChange(false);
  };

  return { token, user, requiresPasswordChange, login, logout, clearPasswordChangeRequirement };
}

